import { render, staticRenderFns } from "./GestionWifi.vue?vue&type=template&id=67d01a41&scoped=true"
import script from "./GestionWifi.vue?vue&type=script&lang=js"
export * from "./GestionWifi.vue?vue&type=script&lang=js"
import style0 from "./GestionWifi.vue?vue&type=style&index=0&id=67d01a41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d01a41",
  null
  
)

export default component.exports